export const contractContent = `# CONTRATO DE LICENCIA DE SOFTWARE COMO SERVICIO (SaaS)

## PricingIntelligence

---

> **AVISO IMPORTANTE:** Este documento es un modelo referencial y requiere revision obligatoria por un abogado habilitado en el Estado Plurinacional de Bolivia antes de su uso. No constituye asesoramiento juridico. Los placeholders indicados entre corchetes [ASI] deben ser completados con la información correspondiente antes de la suscripción del contrato.

---

**Numero de Contrato:** [NUMERO_CONTRATO]

En la ciudad de [CIUDAD], Estado Plurinacional de Bolivia, a los [DIA] dias del mes de [MES] de [ANO], se suscribe el presente Contrato de Licencia de Software como Servicio (en adelante, el "Contrato"), entre:

---

## PARTES CONTRATANTES

**PRIMERA PARTE — EL PROVEEDOR:**

[NOMBRE DE LA EMPRESA], sociedad [TIPO_SOCIEDAD] constituida conforme a las leyes del Estado Plurinacional de Bolivia, inscrita en el Servicio Plurinacional de Registro de Comercio (SEPREC) bajo Matricula No. [MATRICULA_SEPREC], con NIT [NIT], con domicilio legal en [DIRECCION], ciudad de [CIUDAD], representada en este acto por [NOMBRE_REPRESENTANTE_PROVEEDOR], en su calidad de [CARGO_REPRESENTANTE], con facultades suficientes acreditadas mediante [PODER/TESTIMONIO No. Y FECHA], en adelante denominada "el Proveedor" o "PI".

**SEGUNDA PARTE — EL CLIENTE:**

[NOMBRE_EMPRESA_CLIENTE], sociedad [TIPO_SOCIEDAD_CLIENTE] constituida conforme a las leyes de [PAIS_CONSTITUCION], inscrita en [REGISTRO_COMERCIO_CLIENTE], con NIT [NIT_CLIENTE], con domicilio legal en [DIRECCION_CLIENTE], ciudad de [CIUDAD_CLIENTE], representada en este acto por [NOMBRE_REPRESENTANTE_CLIENTE], en su calidad de [CARGO_REPRESENTANTE_CLIENTE], con facultades suficientes acreditadas mediante [PODER/TESTIMONIO_CLIENTE], en adelante denominada "el Cliente".

Conjuntamente denominadas "las Partes" e individualmente "la Parte".

Las Partes, reconociendose mutuamente la capacidad legal suficiente para obligarse, convienen en celebrar el presente Contrato sujeto a las siguientes clausulas:

---

## CLAUSULA PRIMERA — OBJETO DEL CONTRATO

**1.1.** El presente Contrato tiene por objeto establecer los terminos y condiciones bajo los cuales el Proveedor otorga al Cliente una licencia de uso no exclusiva, no transferible y no sublicenciable del software de inteligencia de precios denominado "PricingIntelligence" (en adelante, la "Plataforma"), en la modalidad de Software como Servicio (SaaS), conforme al Plan descrito en el Anexo A.

**1.2.** La Plataforma es accesible a traves de internet en la direccion [URL_PLATAFORMA] y comprende las funcionalidades detalladas en el Anexo A del presente Contrato.

**1.3.** El Proveedor se obliga a prestar el Servicio con la diligencia y profesionalidad propias de su actividad, conforme a los estandares de la industria y a los niveles de servicio establecidos en el Anexo B.

---

## CLAUSULA SEGUNDA — VIGENCIA

**2.1.** El presente Contrato entrara en vigencia a partir de la fecha de su firma y tendra una duracion de [DURACION_CONTRATO] ([DURACION_EN_LETRAS]), contados a partir de [FECHA_INICIO_SERVICIO].

**2.2.** El Contrato se renovara automaticamente por periodos sucesivos de igual duracion, salvo que cualquiera de las Partes notifique por escrito a la otra su intencion de no renovar, con una anticipacion minima de treinta (30) dias calendario al vencimiento del periodo en curso.

**2.3.** El periodo comprendido entre la fecha de firma y la fecha de inicio del Servicio se considerara periodo de implementacion y configuracion, durante el cual el Proveedor asistira al Cliente en la puesta en marcha de la Plataforma.

---

## CLAUSULA TERCERA — PRECIO Y FORMA DE PAGO

**3.1.** El precio del Servicio es de [MONTO_PRECIO] [MONEDA] ([MONTO_EN_LETRAS]) por [PERIODO_FACTURACION] (mensual/anual), mas el Impuesto al Valor Agregado (IVA) del trece por ciento (13%), conforme al detalle del Plan contratado en el Anexo A.

**3.2.** El pago se realizara de forma anticipada, dentro de los primeros [DIAS_PAGO] dias de cada periodo de facturacion, mediante [METODO_PAGO] a la cuenta designada por el Proveedor.

**3.3.** En caso de mora en el pago, se aplicara un interes moratorio equivalente a la tasa maxima permitida por el Banco Central de Bolivia, calculado sobre el monto adeudado desde la fecha de vencimiento hasta la fecha de pago efectivo, sin perjuicio de la facultad del Proveedor de suspender el Servicio conforme a la clausula decima.

**3.4.** El Proveedor podra ajustar el precio del Servicio al inicio de cada periodo de renovacion, notificando al Cliente con al menos sesenta (60) dias de anticipacion. Si el Cliente no acepta el nuevo precio, podra terminar el Contrato sin penalidad conforme a la clausula undecima.

---

## CLAUSULA CUARTA — FACTURACION

**4.1.** El Proveedor emitira la nota fiscal electronica correspondiente por cada pago recibido, conforme a la normativa vigente del Servicio de Impuestos Nacionales (SIN) del Estado Plurinacional de Bolivia.

**4.2.** La nota fiscal incluira:

   a) El detalle del Servicio prestado;
   b) El monto del Servicio sin impuestos;
   c) El Impuesto al Valor Agregado (IVA) del 13%;
   d) El monto total a pagar;
   e) Los datos fiscales del Cliente (razon social y NIT).

**4.3.** El Cliente es responsable de proporcionar datos fiscales correctos y actualizados para la emision de la nota fiscal. El Proveedor no sera responsable por errores en la facturacion derivados de datos incorrectos proporcionados por el Cliente.

---

## CLAUSULA QUINTA — NIVEL DE SERVICIO

**5.1.** El Proveedor se compromete a prestar el Servicio conforme a los niveles de disponibilidad, rendimiento y soporte tecnico establecidos en el Acuerdo de Nivel de Servicio (SLA) que se adjunta como Anexo B del presente Contrato.

**5.2.** En caso de incumplimiento de los niveles de servicio comprometidos, el Cliente tendra derecho a los creditos y compensaciones especificados en el Anexo B.

**5.3.** Los niveles de servicio no se aplicaran durante periodos de mantenimiento programado previamente notificados al Cliente, ni durante eventos de fuerza mayor conforme a la clausula decimotercera.

---

## CLAUSULA SEXTA — CONFIDENCIALIDAD

**6.1.** Las Partes reconocen que, en el curso de la ejecucion del presente Contrato, cada una de ellas podra tener acceso a informacion confidencial de la otra Parte.

**6.2.** Cada Parte se obliga a:

   a) Mantener la mas estricta confidencialidad sobre la Informacion Confidencial de la otra Parte;
   b) No divulgar, publicar, copiar ni reproducir la Informacion Confidencial sin el consentimiento previo y por escrito de la Parte titular;
   c) Utilizar la Informacion Confidencial exclusivamente para los fines del presente Contrato;
   d) Restringir el acceso a la Informacion Confidencial unicamente al personal que necesite conocerla.

**6.3.** Las obligaciones de confidencialidad subsistiran durante la vigencia del Contrato y por un periodo de tres (3) anos contados a partir de su terminacion.

---

## CLAUSULA SEPTIMA — PROPIEDAD INTELECTUAL

**7.1.** La Plataforma, incluyendo su codigo fuente, diseno, interfaz, arquitectura, algoritmos, documentacion, marcas y logotipos, es y continuara siendo propiedad exclusiva del Proveedor.

**7.2.** El presente Contrato no transfiere al Cliente ningun derecho de propiedad intelectual o industrial sobre la Plataforma. El Cliente recibe unicamente una licencia de uso conforme a las condiciones establecidas.

**7.3.** Los datos, informacion, modelos, cotizaciones y demas contenido ingresado o generado por el Cliente en la Plataforma son y continuaran siendo propiedad exclusiva del Cliente.

**7.4.** El Proveedor no adquiere ningun derecho sobre los Datos del Cliente mas alla de la licencia limitada necesaria para prestar el Servicio.

---

## CLAUSULA OCTAVA — PROTECCION DE DATOS PERSONALES

**8.1.** El tratamiento de datos personales en el marco del presente Contrato se rige por la Politica de Privacidad de PricingIntelligence y por la normativa boliviana aplicable.

**8.2.** El Cliente actua como responsable del tratamiento y el Proveedor actua como encargado del tratamiento.

**8.3.** Para Clientes que lo requieran, las Partes podran suscribir un Acuerdo de Procesamiento de Datos (DPA) complementario.

---

## CLAUSULA NOVENA — LIMITACION DE RESPONSABILIDAD

**9.1.** La responsabilidad total acumulada del Proveedor bajo el presente Contrato no excedera el monto total efectivamente pagado por el Cliente en los doce (12) meses inmediatamente anteriores al evento que genere la reclamacion.

**9.2.** El Proveedor no sera responsable por danos indirectos, incidentales, especiales, punitivos, consecuenciales ni por lucro cesante.

---

## CLAUSULA DECIMA — GARANTIAS

**10.1.** El Proveedor declara y garantiza que el Servicio sera prestado de conformidad con los estandares de la industria.

**10.2.** SALVO LAS GARANTIAS EXPRESAS, EL SERVICIO SE PROPORCIONA "TAL CUAL" Y "SEGUN DISPONIBILIDAD".

---

## CLAUSULA UNDECIMA — TERMINACION

**11.1.** Las Partes podran dar por terminado el presente Contrato en cualquier momento por mutuo acuerdo escrito.

**11.2.** Cualquiera de las Partes podra dar por terminado el Contrato sin expresion de causa, mediante notificacion escrita con una anticipacion minima de treinta (30) dias calendario.

**11.3.** Cualquiera de las Partes podra dar por terminado el Contrato de forma inmediata en caso de incumplimiento grave.

---

## CLAUSULA DUODECIMA — EFECTOS DE LA TERMINACION

**12.1.** Una vez producida la terminacion:

   a) El acceso del Cliente a la Plataforma sera desactivado;
   b) El Cliente dispondra de treinta (30) dias para solicitar la exportacion de sus datos en formatos estandar (CSV, JSON, PDF);
   c) Transcurrido el periodo de exportacion, el Proveedor procedera a la eliminacion definitiva de los Datos del Cliente.

---

## CLAUSULA DECIMOTERCERA — FUERZA MAYOR

**13.1.** Ninguna de las Partes sera responsable por el incumplimiento causado por eventos de fuerza mayor o caso fortuito, conforme a lo establecido en los articulos 577 y 578 del Codigo Civil boliviano.

**13.2.** Si el evento de fuerza mayor se prolongara por mas de noventa (90) dias, cualquiera de las Partes podra dar por terminado el Contrato sin responsabilidad.

---

## CLAUSULA DECIMOCUARTA — NOTIFICACIONES

**14.1.** Todas las notificaciones deberan realizarse por escrito a las direcciones designadas por las Partes.

---

## CLAUSULA DECIMOQUINTA — LEY APLICABLE Y JURISDICCION

**15.1.** El presente Contrato se rige e interpreta conforme a las leyes del Estado Plurinacional de Bolivia.

**15.2.** Las controversias seran sometidas primero a negociacion directa y, en caso de no alcanzar acuerdo, a arbitraje institucional.

---

## CLAUSULA DECIMOSEXTA — DISPOSICIONES GENERALES

**16.1.** El presente Contrato, junto con sus Anexos, constituye el acuerdo completo entre las Partes.

**16.2.** Cualquier modificacion debera constar por escrito y ser firmada por representantes autorizados de ambas Partes.

**16.3.** Si alguna disposicion fuera declarada invalida, las restantes conservaran plena vigencia.

---

# ANEXO A — DESCRIPCION DEL SERVICIO POR PLAN

## Plan Starter

| Caracteristica | Detalle |
|---|---|
| Usuarios incluidos | Hasta 5 usuarios |
| Modelos de precios | Hasta 3 modelos activos |
| Cotizaciones mensuales | Hasta 100 cotizaciones |
| Asistente de IA | Incluido (consultas limitadas) |
| SLA de disponibilidad | 99.0% |

## Plan Professional

| Caracteristica | Detalle |
|---|---|
| Usuarios incluidos | Hasta 25 usuarios |
| Modelos de precios | Ilimitados |
| Cotizaciones mensuales | Ilimitadas |
| Asistente de IA | Incluido (consultas ilimitadas) |
| Monitoreo de precios | Incluido |
| SLA de disponibilidad | 99.5% |

## Plan Enterprise

| Caracteristica | Detalle |
|---|---|
| Usuarios incluidos | Ilimitados |
| Modelos de precios | Ilimitados |
| Cotizaciones mensuales | Ilimitadas |
| Asistente de IA | Consultas ilimitadas, contexto extendido |
| Soporte | Dedicado 24/7 |
| DPA | Incluido |
| SLA de disponibilidad | 99.9% |

---

# ANEXO B — ACUERDO DE NIVEL DE SERVICIO (SLA)

## Tiempos de Respuesta de Soporte

| Severidad | Descripcion | Tiempo de Respuesta | Objetivo de Resolucion |
|---|---|---|---|
| Critica | Plataforma inaccesible | 1 hora | 4 horas |
| Alta | Funcionalidad critica no disponible | 4 horas | 24 horas |
| Media | Funcionalidad afectada con solucion alternativa | 8 horas | 72 horas |
| Baja | Consulta general | 24 horas | Segun planificacion |

## Creditos por Incumplimiento

| Disponibilidad Mensual | Credito Aplicable |
|---|---|
| Inferior al SLA pero >= 99.0% | 5% de la cuota mensual |
| >= 95.0% y < 99.0% | 10% de la cuota mensual |
| >= 90.0% y < 95.0% | 25% de la cuota mensual |
| < 90.0% | 50% de la cuota mensual |

---

**FIN DEL CONTRATO Y ANEXOS**

**PricingIntelligence**
**Version del Contrato: 1.0**
`;
